import { TvvBesteldeRoute, usePatchTvvOVRoute, VoertuigsoortDisplay } from "@/entities/tvv";
import {
    Button,
    Dialog,
    DialogBody,
    DialogContainer,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    ErrorDisplay,
    Form,
    FormErrorMessage,
    FormFieldInput,
} from "@/shared/components";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { EditOvRouteData, editOvRouteSchema } from "./schema";

type EditRouteDialogProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    route: TvvBesteldeRoute;
};

export function BewerkOVRouteDialog({ open, setOpen, route }: EditRouteDialogProps) {
    const editTvvBestellingMutation = usePatchTvvOVRoute();

    const form = useForm<EditOvRouteData>({
        resolver: zodResolver(editOvRouteSchema),
        defaultValues: {
            ovLijnNummer: route.ovLijnNummer,
        },
    });

    const errors = form.formState.errors;

    const onSubmit = (payload: EditOvRouteData) => {
        const { id: tvvId, dossierId } = route;
        editTvvBestellingMutation.mutate(
            { dossierId: String(dossierId), tvvId, ...payload },
            {
                onSuccess: () => {
                    setOpen(false);
                },
            }
        );
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContainer>
                <Form {...form}>
                    <form onSubmit={(e) => void form.handleSubmit(onSubmit)(e)}>
                        <DialogHeader>
                            <DialogTitle>{VoertuigsoortDisplay[route.voertuigSoort].replace(" ", "-")} aanpassen</DialogTitle>
                        </DialogHeader>
                        <DialogBody className="grid gap-y-2">
                            {editTvvBestellingMutation.error && <ErrorDisplay error={editTvvBestellingMutation.error} />}
                            <FormFieldInput
                                form={form}
                                name="ovLijnNummer"
                                label="Lijnnummer"
                                labelClassName="text-content-subtle"
                                helpText="Welke lijn kunnen reizigers nemen"
                                className="w-5/7"
                            />
                            {errors.root && <FormErrorMessage>{errors.root.message}</FormErrorMessage>}
                        </DialogBody>

                        <DialogFooter>
                            <Button type="button" variant="tertiary" onClick={() => setOpen(false)}>
                                Annuleren
                            </Button>
                            <Button
                                type="submit"
                                variant="primary"
                                disabled={editTvvBestellingMutation.isPending || !form.formState.isDirty}
                            >
                                Opslaan
                            </Button>
                        </DialogFooter>
                    </form>
                </Form>
            </DialogContainer>
        </Dialog>
    );
}
